import { getNextItem, getPreviousItem } from '@frontend/duck-tape';
import { useState } from '@frontend/react';

export const useStepNavigation = <T extends readonly string[]>(steps: T, initialStep?: T[number]) => {
  const [currentStep, setCurrentStep] = useState<T[number]>((initialStep ?? steps[0]) as T[number]);

  const incrementStep = () => {
    const nextStep = getNextItem(steps, currentStep);
    if (nextStep) {
      setCurrentStep(nextStep);
    }
  };

  const decrementStep = () => {
    const previousStep = getPreviousItem(steps, currentStep);
    if (previousStep) {
      setCurrentStep(previousStep);
    }
  };

  return {
    currentStep,
    decrementStep,
    incrementStep,
    setCurrentStep,
  };
};
